/**
 * Takes an array and flattens any elements that are
 * arrays. The result is a unique set of elements
 * @example
 * list = ['a', 'b', ['a', 'b', 'c', 'd']]
 * => ['a', 'b', 'c', 'd']
 * @param {Array} list - The array to be flattened
 */
const flattenArray = (list = []) => {
  const flat = new Set();
  list.forEach(item => {
    if (Array.isArray(item)) {
      item.forEach(i => flat.add(i));
    } else {
      flat.add(item);
    }
  });
  return Array.from(flat);
};

export default flattenArray;
